import { Outlet } from "react-router-dom";

import { Layout, Content, ContentWrapperNarrow } from "src/components/layout/LayoutComponents";
import PageHeader from "src/components/layout/page-header/PageHeader";
import PageFooter from "src/components/layout/PageFooter";

const AuthenticationPageLayout = () => {
	return (
		<Layout>
			<PageHeader transparentBg showUserArea={false} />
			<Content>
				<ContentWrapperNarrow>
					<Outlet />
				</ContentWrapperNarrow>
			</Content>
			<PageFooter />
		</Layout>
	);
};

export default AuthenticationPageLayout;
